import React from 'react';

const UserLoggedInContext = React.createContext();

export default UserLoggedInContext;
